import React, { useState } from "react";
import "./App.css";
import { Outlet, useLocation } from "react-router-dom";
import PageHeader from "./components/PageHeader/PageHeader";
import TestLogin from "./models/TestLogin";
import PageHeaderPublic from "./components/PageHeader/PageHeaderPublic";
import { useCookies } from "react-cookie";
import WaitingAlert from "./components/WaitingAlert";
import PageHeaderWaiting from "./components/PageHeader/PageHeaderWaiting";
import SharedLandingPage from "./pages/SharedLandingPage";
import TermsAndConditions from "./components/TermsAndConditions";
import config from "./config";
import HomePagePublic from "./pages/HomePagePublic";

function App() {
  const [isLogged, setIsLogged] = useState<boolean>(false);
  const [hasUserGroups, setHasUserGroups] = useState<boolean>(false);
  const [cookies] = useCookies(["userGroups"]);
  const [page, setPage] = useState<string>("home");
  const location = useLocation();

  let [openDialog, setOpenDialog] = useState<boolean>(false);

  React.useEffect(() => {
    console.log(location.pathname);
    (async () => {
      const isLoggedIn = await TestLogin();

      if (isLoggedIn) {
        setIsLogged(true);
        const userGroups = cookies.userGroups ? cookies.userGroups : null;
        //const hasGroups = userGroups && userGroups.length > 0 ? true : false;
        const hasGroups =
          userGroups &&
          Array.isArray(userGroups) &&
          userGroups.length > 0 &&
          userGroups.some((group) =>
            config.portalCognitoGroups.includes(group)
          );

        setHasUserGroups(hasGroups);
      } else {
        location.pathname && location.pathname === "/"
          ? setPage("home")
          : setPage("shared");
      }

      if (process.env.REACT_APP_TARGET_ENV == "dev") {
        // for local test
        setIsLogged(true);
        const userGroups = ["PortalExternalPress", "PortalInternalPress"];

        const hasGroups =
          userGroups &&
          Array.isArray(userGroups) &&
          userGroups.length > 0 &&
          userGroups.some((group) =>
            config.portalCognitoGroups.includes(group)
          );

        console.log("hasGroups " + hasGroups);

        setHasUserGroups(true);
      }
    })();
  }, []);

  return (
    <>
      {isLogged ? (
        <>
          {hasUserGroups ? (
            <div className="font-skyRegular container mx-auto bg-white-100 h-full">
              <PageHeader />
              <Outlet />
            </div>
          ) : (
            <div className="font-skyRegular container mx-auto bg-white-100 h-full">
              <PageHeaderWaiting />
              <WaitingAlert />
              <HomePagePublic />
            </div>
          )}
        </>
      ) : (
        <div className="font-skyRegular container mx-auto bg-white-100 h-full">
          <PageHeaderPublic />
          {page === "shared" && <SharedLandingPage />}
          {page === "home" && <HomePagePublic />}
        </div>
      )}
      <TermsAndConditions
        openDialog={openDialog}
        setOpenDialog={setOpenDialog}
      ></TermsAndConditions>
    </>
  );
}

export default App;
